import UserApi from '../Api/UserApi.js';
import CartApi from '../Api/CartApi.js';
import intToReal from '@helpers/intToReal';

(function (window) {
  const elements = document.querySelectorAll('[data-vue=floatfooter]');
  const instances = [];

  for (const $el of elements) {
    $el.setAttribute(
      'id',
      $el.getAttribute('id') || `floatfooter_${instances.length}`
    );

    const vm = new Vue({
      el: $el,
      components: {
        'mini-cart': () => import('../MiniCart/MiniCart.vue')
      },
      data: {
        userInfo: null,
        loaded: false,
        minicart: null,
        minicartLoaded: false,
        showMenu: false,
        showMinicart: false,
        totalNumberOfItems: 0
      },
      methods: {
        fetchInfo: function () {
          const _self = this;

          UserApi.get()
            .then((res) => {
              if (res) {
                _self.userInfo = res;
              }
            })
            .catch(() => {})
            .then(() => {
              _self.loaded = true;
            });

          CartApi.getItems()
            .then((res) => {
              if (res) {
                _self.minicart = res;
                _self.totalNumberOfItems = this.getTotalNumberOfItems();
              }
            })
            .catch((error) => console.error(error))
            .then(() => {
              _self.minicartLoaded = true;
            });
        },
        getTotalNumberOfItems () {
          let amount = 0;

          if (!this.minicart) {
            return;
          }

          this.minicart.items.forEach((item) => {
            amount += item.unitsAcquired;
          });

          return amount;
        },
        intToReal: intToReal,
        toggleMenu: function (val) {
          const body = document.querySelector('body');
          if (this.showMinicart) {
            this.toggleMinicart();
          }

          this.showMenu = typeof val === 'boolean' ? val : !this.showMenu;

          body.classList[this.showMenu ? 'add' : 'remove'](
            'is-footer-menu-active'
          );
        },
        toggleMinicart: function (event) {
          if (event) {
            event.preventDefault();
          }

          this.showMinicart = !this.showMinicart;

          if (this.showMinicart) {
            Vue.$toast.clear();
          }

          const body = document.querySelector('body');
          body.classList.toggle('is-footer-minicart-active');
        }
      },
      created: function () {
        this.fetchInfo();

        const _self = this;

        window.addEventListener('cart:update', function (e) {
          _self.minicart = e.detail;
          _self.totalNumberOfItems = _self.getTotalNumberOfItems();
        });

        window.addEventListener('user:reload', function (e) {
          _self.userInfo = e.detail;
        });
      }
    });

    instances.push(vm);
  }

  window.loginbox = instances;
})(window);
